import { render, staticRenderFns } from "./developTool.vue?vue&type=template&id=1196c16a&scoped=true&"
import script from "./developTool.vue?vue&type=script&lang=js&"
export * from "./developTool.vue?vue&type=script&lang=js&"
import style0 from "./developTool.vue?vue&type=style&index=0&id=1196c16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196c16a",
  null
  
)

export default component.exports